import { config, type StaticTextDefaultValue } from 'md-editor-v3';
import ja from '~/i18n/locales/ja.json';
import { supportMdEditorConfig } from '~/utils/support-markdown';

// md-editor-v3 reads one global config. It must be in place before the first editor renders.
export default defineNuxtPlugin(() => {
  const copyText = ja.support.code_copy;
  config({
    ...supportMdEditorConfig,
    editorConfig: {
      languageUserDefined: {
        // md-editor-v3 merges a language over en-US, so ja-JP holds only the text of the preview.
        'ja-JP': {
          copyCode: {
            text: copyText.text,
            successTips: copyText.success,
            failTips: copyText.failed,
          },
        } as Partial<StaticTextDefaultValue> as StaticTextDefaultValue,
      },
    },
  });
});
